import { render, staticRenderFns } from "./product_9_dhw.vue?vue&type=template&id=cd9ffb8a&scoped=true"
import script from "./product_9_dhw.vue?vue&type=script&lang=js"
export * from "./product_9_dhw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9ffb8a",
  null
  
)

export default component.exports